import React from 'react';

/**
 * Shopify night shelf — rounded overlap under the hero.
 * One headline, one support line.
 */
const MarketingLayerBand = () => {
  return (
    <section className="marketing-layer px-4 pb-14 pt-8 sm:px-6 sm:pb-20 sm:pt-10">
      <div className="mx-auto w-full max-w-5xl">
        <h2 className="marketing-section-title mb-3 text-m-on-dark">
          Unique vendors for events, meetings, photo &amp; film
        </h2>
        <p className="marketing-body-lg max-w-3xl text-white/85">
          From indie films to boardroom celebrations — browse verified providers,
          lock dates, and pay by the package without the chaos.
        </p>
      </div>
    </section>
  );
};

export default MarketingLayerBand;
